import { createContext } from 'react'

export interface SiteSettings {
  title: string
  description: string
  keywords: string[]
  contact: {
    email: string
    phone?: string
    address?: string
  }
  social: {
    facebook?: string
    instagram?: string
    linkedin?: string
    twitter?: string
  }
}

export interface SiteSettingsContextType {
  settings: SiteSettings
  loading: boolean
  error: string | null
}

// Hardcoded site settings
export const defaultSettings: SiteSettings = {
  title: 'Demirix - Strategic IT Consulting & Digital Solutions',
  description: 'Strategic technology consulting and digital transformation services. Empowering businesses with innovative IT solutions and expert technical guidance across the UAE and globally.',
  keywords: ['IT consulting Dubai', 'web development', 'cloud solutions', 'AI solutions', 'Web3 blockchain', 'startup technology consulting', 'digital transformation'],
  contact: {
    email: 'info@demirix.com',
    phone: '+971 4 123 4567',
    address: 'Dubai, United Arab Emirates'
  },
  social: {
    facebook: 'https://www.facebook.com/share/gP6uwno2b9Z5aYPH/?mibextid=LQQJ4d',
    instagram: 'https://www.instagram.com/demirix_com',
    linkedin: 'https://linkedin.com/company/demirix',
    twitter: 'https://x.com/Demirix_com'
  }
}

export const SiteSettingsContext = createContext<SiteSettingsContextType>({
  settings: defaultSettings,
  loading: false,
  error: null
})